export default __webpack_public_path__ + "static/media/EMprint Light.752ea2b6.woff2";